export default function HostTwo() {
  return (
    <div className="flex flex-col gap-4">
      <div className="relative">
        <div className="bg-gradient-blur opacity-20 animate-pulse-soft"></div>
        <svg
          width="254"
          height="222"
          viewBox="0 0 254 222"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full"
        >
          <path
            d="M12 1H242C248.075 1 253 5.92487 253 12V210C253 216.075 248.075 221 242 221H12C5.92486 221 1 216.075 1 210V12C1 5.92487 5.92487 1 12 1Z"
            fill="black"
          />
          <path
            d="M12 1H242C248.075 1 253 5.92487 253 12V210C253 216.075 248.075 221 242 221H12C5.92486 221 1 216.075 1 210V12C1 5.92487 5.92487 1 12 1Z"
            fill="url(#paint0_radial_0_1)"
            fillOpacity="0.5"
          />
          <path
            d="M12 1H242C248.075 1 253 5.92487 253 12V210C253 216.075 248.075 221 242 221H12C5.92486 221 1 216.075 1 210V12C1 5.92487 5.92487 1 12 1Z"
            stroke="#181526"
            strokeWidth="2"
          />
          <path
            d="M12 1H242C248.075 1 253 5.92487 253 12V210C253 216.075 248.075 221 242 221H12C5.92486 221 1 216.075 1 210V12C1 5.92487 5.92487 1 12 1Z"
            stroke="url(#paint1_radial_0_1)"
            strokeWidth="2"
          />
          <circle
            cx="127.348"
            cy="90.348"
            r="2.348"
            fill="#4CC054"
            className="animate-pulse-stagger-1"
          />
          <circle
            cx="127.348"
            cy="136.348"
            r="2.348"
            fill="#4CC054"
            className="animate-pulse-stagger-3"
          />
          <circle
            cx="102.348"
            cy="113.348"
            r="2.348"
            fill="#4CC054"
            className="animate-pulse-stagger-5"
          />
          <circle
            cx="151.032"
            cy="113.348"
            r="2.348"
            fill="#4CC054"
            className="animate-pulse-stagger-7"
          />
          <circle
            cx="108.32"
            cy="96.3206"
            r="2.348"
            transform="rotate(45 108.32 96.3206)"
            fill="#4CC054"
            className="animate-pulse-stagger-2"
          />
          <circle
            cx="145.32"
            cy="130.321"
            r="2.348"
            transform="rotate(45 145.32 130.321)"
            fill="#4CC054"
            className="animate-pulse-stagger-4"
          />
          <circle
            cx="145.32"
            cy="96.3203"
            r="2.348"
            transform="rotate(135 145.32 96.3203)"
            fill="#4CC054"
            className="animate-pulse-stagger-6"
          />
          <circle
            cx="108.32"
            cy="130.32"
            r="2.348"
            transform="rotate(135 108.32 130.32)"
            fill="#4CC054"
            className="animate-pulse-stagger-8"
          />
          <defs>
            <radialGradient
              id="paint0_radial_0_1"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(135.194 -43.313) rotate(90) scale(312.552 306.173)"
            >
              <stop stopColor="#0C3D38" />
              <stop offset="1" stopColor="#08080E" stopOpacity="0" />
            </radialGradient>
            <radialGradient
              id="paint1_radial_0_1"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(-5.20682 63.7209) rotate(9.33561) scale(291.364 263253)"
            >
              <stop offset="0.02" stopColor="#4CC054" stopOpacity="0.2" />
              <stop offset="0.31" stopColor="#4CC054" />
              <stop offset="1" stopColor="#1D2132" stopOpacity="0" />
            </radialGradient>
          </defs>
        </svg>
      </div>
    </div>
  )
}
